<template>
  <b-alert ref="Main"
           class="mb-0 fixed-top in-maintenance"
           :show = "!this.$store.getters['auth/isLoggedAs'] && this.$store.getters['auth/inMaintenance']"
           variant="warning">
    This scope <strong>{{this.$store.getters["auth/scopeDefault"].name}}</strong> is in Maintenance
  </b-alert>
</template>

<script>
  export default {
    name: "AppScopeInMaintenance",
  }
</script>

<style scoped>

</style>
